import React, { ComponentType, lazy } from 'react';

// Lazy load pages for better code splitting
export const LazyHome = lazy(() => import('../pages/Home'));
export const LazyAbout = lazy(() => import('../pages/About'));
export const LazyServices = lazy(() => import('../pages/Services'));
export const LazyServiceDetail = lazy(() => import('../pages/ServiceDetail'));
export const LazyPlanes = lazy(() => import('../pages/Planes'));
export const LazyContact = lazy(() => import('../pages/Contact'));
export const LazyBlog = lazy(() => import('../pages/Blog'));
export const LazyBlogPostDetail = lazy(() => import('../pages/BlogPostDetail'));
export const LazyCaseStudies = lazy(() => import('../pages/CaseStudies'));
export const LazyCaseStudyDetail = lazy(() => import('../pages/CaseStudyDetail'));
export const LazySearchResults = lazy(() => import('../pages/SearchResults'));
export const LazyCookiePreferences = lazy(() => import('../pages/CookiePreferences'));

// Lazy load heavy components
export const LazyExpandableCharts: ComponentType<any> = lazy(
  () => import('../components/ExpandableCharts')
);
export const LazyTestimonialCarousel: ComponentType<any> = lazy(
  () => import('../components/TestimonialCarousel')
);
export const LazyConversionFunnel: ComponentType<any> = lazy(
  () => import('../components/ConversionFunnel')
);

// Assuming BlogAnalyticsDashboard is exported as: export const BlogAnalyticsDashboard = ...
export const LazyBlogAnalyticsDashboard: ComponentType<any> = lazy(() =>
  import('../components/BlogAnalyticsDashboard').then(module => ({
    default: module.BlogAnalyticsDashboard,
  }))
);
export const LazyCustomPlanBuilder: ComponentType<any> = lazy(
  () => import('../components/CustomPlanBuilder')
);
export const LazyMultidimensionalImpactChart: ComponentType<any> = lazy(
  () => import('../components/MultidimensionalImpactChart')
);
export const LazyROIServiceChart: ComponentType<any> = lazy(
  () => import('../components/ROIServiceChart')
);
export const LazyDigitalImpactChart: ComponentType<any> = lazy(
  () => import('../components/DigitalImpactChart')
);
export const LazyInvestmentGrowthChart: ComponentType<any> = lazy(
  () => import('../components/InvestmentGrowthChart')
);
export const LazyImprovementDistributionChart: ComponentType<any> = lazy(
  () => import('../components/ImprovementDistributionChart')
);

// Component loading error boundary - Simplified Version
export const ComponentLoadingError: React.FC<{
  error: Error;
  retry: () => void;
}> = ({ error, retry }) => (
  <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
    <p className="text-red-600 mb-2">Error al cargar el componente: {error.message}</p>
    <button onClick={retry} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
      Reintentar
    </button>
  </div>
);

// Loading fallback component - Simplified Version
export const ComponentLoadingFallback: React.FC<{ message?: string }> = ({
  message = 'Cargando...',
}) => (
  <div className="flex items-center justify-center min-h-[200px]">
    <div className="text-center">
      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 mx-auto mb-2"></div>
      <p className="text-gray-600">{message}</p>
    </div>
  </div>
);
